/**
 * Chess Piece Component (CSS Theme)
 * Uses CSS classes from chess-components.css for all styling
 */
import type { PieceProps } from "../../types";
import { PieceBase } from "./PieceBase";

export function PieceThemed({ piece, isAugmented }: PieceProps) {
  const colorClass =
    piece.color === "WHITE" ? "chess-piece-white" : "chess-piece-black";
  const augmentedClass = isAugmented ? " chess-piece-augmented" : "";

  return (
    <PieceBase
      piece={piece}
      className={`chess-piece ${colorClass}${augmentedClass}`}
    />
  );
}
